import { render, staticRenderFns } from "./Newcomer.vue?vue&type=template&id=b3352c12&scoped=true&"
import script from "./Newcomer.vue?vue&type=script&lang=js&"
export * from "./Newcomer.vue?vue&type=script&lang=js&"
import style0 from "./Newcomer.vue?vue&type=style&index=0&id=b3352c12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3352c12",
  null
  
)

export default component.exports